import { useSession } from "../context/SessionContext";
import {
  limiteDeKit,
  podeCriarKit,
  RecursoKit,
  usoDeKits,
} from "../lib/kitLimits";

/**
 * Acesso do médico derivado de `SessionContext.billing` (GET /billing/assinatura).
 *
 * OCR e voz→texto só no plano pago (`features`, ou `nivel === "completo"`
 * enquanto o backend antigo não mandar `features`). Pedido, recurso e PDF
 * são ilimitados no Básico. O teto é só criação de kits (`limites`/`uso`).
 */
export function useAccess() {
  const { billing, adminStatus, papel, metadata } = useSession();
  const level = billing?.nivel ?? null;
  const hasFullAccess = level === "completo";
  const isAdmin = adminStatus?.is_admin === true;

  const canUseOcr = billing?.features?.ocr ?? hasFullAccess;
  const canUseVoice = billing?.features?.voz ?? hasFullAccess;

  const isClinicPlan =
    billing?.modo === "clinica" || (billing?.plano?.quantidade ?? 0) > 1;
  const canManageClinic = isClinicPlan && papel === "dono";
  const canManageSecretaries =
    papel !== "secretaria" && metadata.role !== "secretary";
  // Cortesia (UI: "Parceria") = clínica em acesso experimental concedido pela LetsDoc.
  const isCourtesy = billing?.modo === "clinica" && billing?.origem === "concessao_manual";
  const canViewBilling =
    papel === "dono" && !isAdmin && billing?.modo !== undefined && !isCourtesy;
  const canManagePlan = canViewBilling && billing?.modo !== "clinica";

  return {
    level,
    hasFullAccess,
    canUseOcr,
    canUseVoice,
    kitLimit: (resource: RecursoKit) => limiteDeKit(billing, resource),
    canCreateKit: (resource: RecursoKit) => podeCriarKit(billing, resource),
    kitUsage: usoDeKits(billing),
    isAdmin,
    isClinicPlan,
    canManageClinic,
    canManageSecretaries,
    isCourtesy,
    canViewBilling,
    canManagePlan,
  };
}
